module.exports = __webpack_public_path__ + "static/media/web.61d7ae19.svg";